import React from 'react'
import '../assets/css/style.css'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from '../pages/HomePage';
import ToxicologyTestingPage from '../pages/ToxicologyTestingPage';
import BloodTestingPage from '../pages/BloodTestingPage';
import StiPage from '../pages/StiPage';
import PanelTestingPage from '../pages/PanelTestingPage';
import RSVTestingPage from '../pages/RSVTestingPage';
import InfluenzaTestingPage from '../pages/InfluenzaTestingPage';
import PathogenPage from '../pages/PathogenPage';
import CovidTestingPage from '../pages/CovidTestingPage';
import CovidWorkplacePage from '../pages/CovidWorkplacePage';
import AboutPage from '../pages/AboutPage';
import BloodTestingLombardPage from '../pages/ads/BloodTestingLombardPage';
import ToxicologyTestForm from '../components/appointment-forms/ToxicologyTestForm';
import BloodTestForm from '../components/appointment-forms/BloodTestForm';
import STITest from '../components/appointment-forms/STITest';
import PanelTestForm from '../components/appointment-forms/PanelTestForm';
import CovidTestForm from '../components/appointment-forms/CovidTestForm';
import WalkInAppointmentForm from '../components/appointment-forms/WalkInAppointmentForm';
import AppointmentPage from '../pages/AppointmentPage';
import ContactPage from '../pages/ContactPage';


const Path = () => {
  return (
    <div>
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<HomePage/>} />
                <Route path='/about' element={<AboutPage/>} />
                <Route path='/toxicology-and-drug-testing-chicago' element={<ToxicologyTestingPage/>} />
                <Route path='/blood-test-lab-in-chicago' element={<BloodTestingPage/>} />
                <Route path='/sti-and-std-testing-in-chicago' element={<StiPage/>} />
                <Route path='/services' element={<PanelTestingPage/>} />
                <Route path='/rsv-testing-in-chicago-il' element={<RSVTestingPage/>} />
                <Route path='/influenza-testing-in-chicago-il' element={<InfluenzaTestingPage />} /> 
                <Route path='/respiratory-pathogen-panel-testing-in-chicago' element={<PathogenPage/>} /> 
                <Route path='/covid-and-rt-pcr-test-in-chicago-il' element={<CovidTestingPage/>} /> 
                <Route path='/workplace-covid-19-test-in-chicago' element={<CovidWorkplacePage/>} /> 
                <Route path='/toxicology-test-appointment' element={<ToxicologyTestForm/>} />
                <Route path='/general-blood-test-appointment' element={<BloodTestForm/>} />
                <Route path='/sti-std-test-appointment' element={<STITest/>} />
                <Route path='/book-panel-test-appointment' element={<PanelTestForm/>} />
                <Route path='/book-covid-test-appointment' element={<CovidTestForm/>} />
                <Route path='/walk-in-appointment' element={<WalkInAppointmentForm/>} />
                <Route path='/book-appointment' element={<AppointmentPage/>} /> 
                <Route path='/contact' element={<ContactPage/>} /> 
                
                
                <Route path='/blood-testing-lombard' element={<BloodTestingLombardPage/>} /> 
            </Routes>
        </BrowserRouter>
    </div>
  )
}

export default Path